import React, {PureComponent} from 'react'
import {Button, Form, Icon, notification, Select, Tabs} from 'antd'
import {connect} from 'react-redux'

import PageHeaderWrapper from '../../components/PageHeaderWrapper'
// import  from 'sz-react-utils'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import {hideLoader, showLoader} from '../../modules/actions'
import Request, {API_URL} from '../../request'


// const config = {
//     rules: [{type: 'object', required: true, message: 'Please select time!'}]
// }

// following variables needed for update country    

@Form.create()
class UpdateProfile extends PureComponent {


    handleSubmit = e => {
        const {dispatch, form} = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                if (!valData.oldPassword) {
                    return notification.error({
                        message: 'Please add your current password'
                    })
                }
                if (valData.password.length < 8) {
                    return notification.error({
                        message: 'Password too small'
                    })
                }

                if (valData.password !== valData.confirmPassword) {
                    return notification.error({
                        message: 'Password and Confirm password mismatch'
                    })
                }
                dispatch(showLoader())
                let {error, message} = await Request.updateUserPassword(valData)
                if (!error) {
                    notification.success({
                        message: 'Profile Updated successfully',
                        description: message
                    })
                    form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: message
                    })
                }

                dispatch(hideLoader())
            }
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()

        this.state = {
            file: null
        }
    }

    async componentDidMount() {
        /*let { data } = await Request.getUpdateProfile()
        if (data.userImage && data.userImage.url) {
          this.props.form.setFieldsValue({ userImage: [data.userImage] })
        }*/
    }

    render() {
        const {
            form: {getFieldDecorator,}
        } = this.props

        let inputTypes = {
            fields: [
                /*  {
                    label: 'Upload Image',
                    key: 'userImage',
                    type: 'file',
                    limit: 1,
                    defaultFileList: []
                  },*/
                {
                    label: 'Old Password',
                    key: 'oldPassword',
                    type: 'password',
                    placeholder: 'Enter Old Password',
                    required: true
                },
                {
                    label: 'New Password',
                    key: 'password',
                    type: 'password',
                    placeholder: 'Minimum 8 letter password',
                    required: true
                },
                {
                    label: 'Confirm Password',
                    key: 'confirmPassword',
                    type: 'password',
                    placeholder: 'Minimum 8 letter password',
                    required: true
                }
            ]
        }

        // const formItemLayout = {
        //     labelCol: {
        //         xs: {span: 24},
        //         sm: {span: 8},
        //         md: {span: 8}
        //     },
        //     wrapperCol: {
        //         xs: {span: 24},
        //         sm: {span: 16},
        //         md: {span: 12}
        //     }
        // }

        // const submitFormLayout = {
        //     wrapperCol: {
        //         xs: {span: 24, offset: 0},
        //         sm: {span: 10, offset: 7},
        //         md: {span: 12, offset: 8}
        //     }
        // }
        // const uploadButton = (
        //     <div>
        //         <Icon type="plus"/>
        //         <div className="ant-upload-text">Upload</div>
        //     </div>
        // )

        return (
            <PageHeaderWrapper title={'Update Profile'}>
                <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                    <GetAllFormFields
                        apiurl={API_URL}
                        inputSchema={inputTypes}
                        refresh={this.refreshFxn}
                        getFieldDecorator={getFieldDecorator}
                    />
                    <Button
                        type="primary"
                        htmlType="submit"
                        style={{marginBottom: 10, marginLeft: '33%'}}
                        loading={this.props.loading}>
                        UPDATE
                    </Button>
                </Form>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateProfile)
